import React from 'react'
import { SkeletonParagraphProps } from './Skeleton.types'
import { StyledBox } from './styled'
import Flex from '../Flex'
import { range } from '../../utils/locDash'

const Paragraph: React.FC<SkeletonParagraphProps> = ({
  height = '24px',
  width = '100%',
  gap = '8px',
  rows = 3,
  color = 'black5',
  ...props
}) => {
  return (
    <Flex gap={gap} flexDirection='column' width={width}>
      {range(rows).map((_, index) => (
        <StyledBox
          height={height}
          width={width}
          backgroundColor={color}
          borderRadius='8px'
          {...props}
          key={index}
        />
      ))}
    </Flex>
  )
}

export default Paragraph
